document.addEventListener("DOMContentLoaded", function () {

  const sections = document.querySelectorAll(".tp-gift-builder");

  sections.forEach(function (section) {

    const giftBoxes = section.querySelectorAll(".tp-gift-box");
    const steps = section.querySelectorAll(".tp-gift-step");

    /* =====================================================
       GIFT BOX HOVER
       ===================================================== */

    giftBoxes.forEach(function (box) {

      box.addEventListener("mouseenter", function () {
        box.classList.add("is-hovered");
      });

      box.addEventListener("mouseleave", function () {
        box.classList.remove("is-hovered");
      });

    });


    /* =====================================================
       STEP REVEAL ON SCROLL
       ===================================================== */

    if ("IntersectionObserver" in window) {

      const observer = new IntersectionObserver(
        function (entries, observerInstance) {

          entries.forEach(function (entry) {

            if (entry.isIntersecting) {

              entry.target.classList.add("is-visible");

              observerInstance.unobserve(entry.target);

            }

          });

        },
        {
          threshold: 0.12
        }
      );


      steps.forEach(function (step) {
        observer.observe(step);
      });

    } else {

      steps.forEach(function (step) {
        step.classList.add("is-visible");
      });

    }

  });


  /* =====================================================
     WHATSAPP CTA
     Dashboard number + message se automatically
     WhatsApp link generate hoga.
     ===================================================== */

  document.querySelectorAll(
    ".tp-gift-builder__cta-button, .tp-gift-builder__build-btn"
  ).forEach(function (button) {

    button.addEventListener("click", function () {

      const whatsappLink = button.getAttribute("href");

      if (
        whatsappLink &&
        whatsappLink.indexOf("wa.me") !== -1
      ) {
        return;
      }

    });

  });

});